import { Injectable } from '@angular/core';
import * as olProj from 'ol/proj';
import olMap from 'ol/Map';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { MapService } from './map.service';
import { Draw } from 'ol/interaction';

import { createBox } from 'ol/interaction/Draw';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TerrainAltitudeCutComponent } from '../popup/tools/terrain-altitude-cut/terrain-altitude-cut.component';
import { EventListenersOnMap } from 'src/app/utils/eventListenersOnMap';


@Injectable({
  providedIn: 'root'
})
export class TerrainAltitudeCutService {

  draw: Draw;
  map: olMap;
  static readonly EVENT_ON_MAP_LABEL: string = 'Terrain Altitude Cut';


  constructor(private mapService: MapService, private popupService: BsModalService) {
    this.map = mapService.getMap('map');
  }

  openTerrainAltitudeCut() {



    if (this.draw != null) {
      this.map.removeInteraction(this.draw);
    }

    if (this.mapService.draw != null) {
      this.map.removeInteraction(this.mapService.draw);
      this.map.removeInteraction(this.mapService.select);
      this.mapService.draw = null;
    }

    EventListenersOnMap.addEventListener(TerrainAltitudeCutService.EVENT_ON_MAP_LABEL,'pointermove',function (evt) {}, true);


    const source = new VectorSource();

    this.draw = new Draw({
      source: source,
      type: "Circle",
      geometryFunction: createBox(),
    });

    this.map.addInteraction(this.draw);
    let context = this;

    this.draw.on('drawend', function (endEvent) {

      context.map.removeInteraction(context.draw);
      context.draw = null;
      EventListenersOnMap.RemoveEventListener(TerrainAltitudeCutService.EVENT_ON_MAP_LABEL, true);


      // Open modal
      const bsModalRef: BsModalRef = context.popupService.show(TerrainAltitudeCutComponent);
      bsModalRef.content.feature = endEvent.feature;

    });

  }


  clearListeners() {
    this.map.removeInteraction(this.draw);
    this.draw = null;

    EventListenersOnMap.RemoveEventListener(TerrainAltitudeCutService.EVENT_ON_MAP_LABEL, true);
  }

}
